import { DataBean } from "../DataBean";

export class RequirementStep extends DataBean {
    
    


    public async getRequirementStepCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getRequirementStepCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getProjectCatalogPorPropiedadesRender(props:any,rows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectCatalogPorPropiedadesRender_java.util.Map_Number", [props,rows]);
    }
  

}